export var FilterSetUtilityData;
(function (FilterSetUtilityData) {
    FilterSetUtilityData["FilterType"] = "filterType";
})(FilterSetUtilityData || (FilterSetUtilityData = {}));
export var FilterSetStatus;
(function (FilterSetStatus) {
    FilterSetStatus["IN_USE"] = "IN_USE";
    FilterSetStatus["NOT_IN_USE"] = "NOT_IN_USE";
})(FilterSetStatus || (FilterSetStatus = {}));
